import Typography from 'components/Typography/Typography'
import { ReactComponent as HospitalIcon } from 'assets/svg/Hospital.svg'
import './styles.scss'
import { Button, BUTTON_TYPES } from 'components/Button'
import { ReactComponent as Plus16 } from 'assets/svg/Plus16.svg'
import { BTN_TXT } from '../../../constants'
import { useNavigate } from 'react-router'
import { routes } from '../../../router'
import { useParams } from 'react-router-dom'
import useRouter from '../../../hooks/useRouter'
import { TBusinessDetailsEmptyState } from './types'

export const VendorBusinessDetailsEmptyState = ({
  onClick
}: TBusinessDetailsEmptyState) => {
  const navigate = useNavigate()
  const { hospitalId } = useParams()

  const {
    query: { hsId }
  } = useRouter()

  const handleRedirect = () => {
    if (onClick) {
      onClick()
    } else
      navigate(
        `${hospitalId ? routes.hospitals + '/' + hospitalId : ''}${
          routes.addBusinessDetails
        }${hsId ? `?hsId=` + hsId : ''}`
      )
  }

  return (
    <div className="business-details-container__empty-state row justify-center">
      <div className="business-details-container__empty-state__wrapper column align-center">
        <HospitalIcon />
        <Typography.Headline6 className="mt-32">
          Provide your business information to enable payments <br />
          and compliance verification.
        </Typography.Headline6>
        <Typography.Paragraph className="mt-8">
          Your information is handled securely <br />
          by our payment provider.
        </Typography.Paragraph>
        <Button
          className="contract-categories__add-btn mt-24"
          onClick={handleRedirect}
          icon={<Plus16 />}
          type={BUTTON_TYPES.PRIMARY}
          upperCase
          medium
        >
          {BTN_TXT.ADD_BUSINESS_DETAILS}
        </Button>
      </div>
    </div>
  )
}
